import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const APP_ID = process.env.REACT_APP_APP_ID;

const $api = axios.create({
  baseURL: API_URL,
});

$api.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  config.headers["noodlz-app-id"] = APP_ID;
  return config;
});

$api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    const refreshToken = localStorage.getItem("refreshToken");
    if (error.response && error.response.status === 401 && refreshToken) {
      try {
        const { data } = await axios.post(`${API_URL}/auth/refresh`, {
          refresh_token: refreshToken,
        });

        localStorage.setItem("token", data.token);
        return $api.request(originalRequest);
      } catch (e) {
        throw e;
      }
    }
    return Promise.reject(error);
  }
);

export default $api;
